
export class VerticalRevealText {
  get actual() { return this._actual };
  set actual(_actual) {
    this._actual = _actual;
    this.item.style.setProperty('--value', this._actual);
  }

  constructor(dom) {
    this.item = dom;
    this.actual = 0;
  };
}